module.exports = {
  type: 'hex-button',
  group: 'button',
  name: 'iview按钮',
  isForm: true,
  props: {
    innerText: {
      name: '文字',
      default: '11',
      isMain: true,
      isFormShowName: true,
      isFormField: true,
      show: {
        prop: 'isChooseDataSource',
        value: '1'
      }
    },
    '[a]': {
      name: '主动调用',
      _$event: '',
      type: 'hidden',
    },
    //  暂定还用原属性 但需要重新处理
    complexEvents: {
      name: '复杂方法',
      type: 'complex-events',
      _$event: 'click',
      _$eventParams: [{desc: '文字', arg: 'innerText'}],
      default: [{
        type: 'click',
        bind: '',
        repetitive: false,
        rate: 500,
        tip: ''
      }],
      values: []
    },

    class: {
      name: '控件类名',
      default: ''
    },
    type: {
      name: '按钮类型',
      default: 'primary',
      type: 'enum',
      values: [{
        value: 'primary',
        text: '默认'
      }, {
        value: 'info',
        text: '信息'
      }, {
        value: 'success',
        text: '成功'
      }, {
        value: 'warning',
        text: '警告'
      },
        {
          value: 'error',
          text: '失败'
        }]
    },
    shape: {
      name: '形状类型',
      default: 'string',
      type: 'enum',
      values: [{
        value: 'circle',
        text: '圆型'
      }, {
        value: '',
        text: '正常'
      }]
    }
  },
  style: {},
  // 新的events 用来处理编译用
  interfaces: {
  },

  // events 保证原来不报错
  events: {}
}



// WEBPACK FOOTER //
// ./packages/components/button/src/define.js